// client/src/pages/PaymentSuccess.js

import React, { useEffect, useState } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function PaymentSuccess() {
  const stripe = useStripe();
  const navigate = useNavigate();

  const [status, setStatus] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [orderId, setOrderId] = useState('');

  useEffect(() => {
    if (!stripe) return;

    const params = new URLSearchParams(window.location.search);
    const clientSecret = params.get('payment_intent_client_secret');

    if (!clientSecret) {
      setErrorMsg('No payment_intent_client_secret found.');
      return;
    }

    // Retrieve PaymentIntent
    stripe.retrievePaymentIntent(clientSecret)
      .then(({ paymentIntent }) => {
        if (!paymentIntent) {
          setErrorMsg('PaymentIntent not found');
          return;
        }

        if (paymentIntent.status === 'succeeded') {
          setStatus('Payment succeeded!');
          // Create order in DB
          storeOrder(paymentIntent.id);
        } else if (paymentIntent.status === 'processing') {
          setStatus('Payment is processing...');
        } else {
          setStatus(`Payment status: ${paymentIntent.status}`);
        }
      })
      .catch(err => {
        console.error(err);
        setErrorMsg(err.message || 'Error retrieving PaymentIntent');
      });
  }, [stripe]);

  const storeOrder = async (paymentIntentId) => {
    try {
      const cart = JSON.parse(localStorage.getItem('cart')) || [];
      let total = 0;
      const orderItems = cart.map(item => {
        const lineTotal = item.price * item.quantity;
        total += lineTotal;
        return {
          productId: item.id,
          quantity: item.quantity,
          price: item.price
        };
      });

      total = Math.round(total * 100) / 100;

      const token = localStorage.getItem('authToken');
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/orders`,
        {
          orderItems,
          totalPrice: total,
          paymentIntentId
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setOrderId(data._id);
      // clear cart
      localStorage.removeItem('cart');
    } catch (err) {
      console.error('Error storing order:', err);
      setErrorMsg(err.response?.data?.error || 'Failed to store order');
    }
  };

  const goHome = () => {
    navigate('/');
  };

  return (
    <div className="max-w-md mx-auto p-4 mt-16 text-center">
      <h1 className="text-2xl font-bold mb-4">Payment Status</h1>
      {errorMsg && <p className="text-red-500 mb-4">{errorMsg}</p>}
      {status && <p className="text-green-600 mb-4">{status}</p>}
      {orderId && <p>Your order # is <strong>{orderId}</strong></p>}

      <button onClick={goHome} className="bg-primaryGreen text-white px-4 py-2 rounded mt-8">
        Go Home
      </button>
    </div>
  );
}
